import React from 'react';
import {Card, CardBody} from "reactstrap";
import Parser from "react-html-parser";
import {connect} from "react-redux";
import * as PropTypes from "prop-types";
import CintRequirePostalCodeModal from "./CintRequirePostalCodeModal";

function SurveyBodyInvitation({surveyResponse}) {
  return (
    <Card className={"invitation-card"}>
      <CardBody className="invitation-text ck-content">
        {Parser(surveyResponse.invitationText)}

        {(surveyResponse.survey.cintProjectId && surveyResponse.user) && <CintRequirePostalCodeModal />}
      </CardBody>
    </Card>
  );
}

SurveyBodyInvitation.propTypes = {
  surveyResponse: PropTypes.shape({
    survey: PropTypes.shape({
      cintProjectId: PropTypes.number,
    }).isRequired,
  }).isRequired,
};

function mapStateToProps(state) {
  return {
    surveyResponse: state.surveyResponse,
  }
}

export default connect(mapStateToProps)(SurveyBodyInvitation);